import { useMutation, useQueryCache } from 'react-query';
import { addAssistants } from 'src/services/api/users';

function useAddAssistants() {
  const queryCache = useQueryCache();

  return useMutation(({ user, data }) => addAssistants(user, data), {
    onSuccess: (data) => queryCache.setQueryData(['user', data.data?.id], data),
  });
}

export default useAddAssistants;
